angular.module('autoremind.dashboard.directives')
    .directive('messaging', ['$rootScope', '$parse', 'messagesService', '$interval', '$location', '$timeout',
    function ($rootScope, $parse, messagesService, $interval, $location, $timeout) {
        return {
            templateUrl: 'app/dashboard/widgets/messaging/messaging.html',
            restrict: 'EA',
            scope: true,
            link: function (scope, elem, attr) {
                scope.params = $parse(attr.params)(scope);
                console.log('scope.params', scope.params);
                scope.viewModel = {
                    stats: {
                        emailSent: {
                            value: 0,
                            icon: 'img/icons/media-email.png'
                        },
                        smsSent: {
                            value: 0,
                            icon: 'img/icons/media-sms.png'
                        },
                        // todayTotalSent : {
                        //     value : null,
                        //     icon : ''
                        // },
                        voiceSent: {
                            value: 0,
                            icon: 'img/icons/media-voice.png'
                        }
                    },
                    classOfChangingPeriod: 'changingOfPeriod',
                    currentPeriod: {
                        period: 'today',
                        widgetHeader: '_messagesSentTodayWidget_'
                    },
                    periodsOfStats: ['today', '7days', '30days'],
                    fetchingStatsMethodSet: {
                        'today': {
                            method: messagesService.getMessagesStatsToday,
                            isUpdated: false,
                            values: {
                                todayEmailSent: 0,
                                todaySmsSent: 0,
                                todayTotalSent: 0,
                                todayVoiceSent: 0
                            }
                        },
                        '7days': {
                            method: messagesService.getMessagesStats7Days,
                            isUpdated: false,
                            values: {
                                last7DaysEmailSent: 0,
                                last7DaysSmsSent: 0,
                                last7DaysTotalSent: 0,
                                last7DaysVoiceSent: 0
                            }
                        },
                        '30days': {
                            method: messagesService.getMessagesStats30Days,
                            isUpdated: false,
                            values: {
                                last30DaysEmailSent: 0,
                                last30DaysSmsSent: 0,
                                last30DaysTotalSent: 0,
                                last30DaysVoiceSent: 0
                            }
                        }
                    },
                    isUpdated: false,
                    updateInterval: angular.isDefined(scope.params.settings) && angular.isDefined(scope.params.settings.updateInterval) ? scope.params.settings.updateInterval : false,
                    isBusy: false
                };
                scope.getMessagesTodayStats = function () {
                    var currentPeriod = angular.copy(scope.viewModel.currentPeriod.period);
                    var getterOfMessagesStats = scope.viewModel.fetchingStatsMethodSet[currentPeriod].method;
                    getterOfMessagesStats()
                        .then(function (data) {
                        console.log('getMessagesStats: Stats have been got');
                        scope.viewModel.isBusy = false;
                        if (angular.isDefined(data.messagesSentStats)) {
                            angular.extend(scope.viewModel.fetchingStatsMethodSet[currentPeriod].values, data.messagesSentStats);
                        }
                        scope.viewModel.fetchingStatsMethodSet[currentPeriod].isUpdated = true;
                        if (currentPeriod === scope.viewModel.currentPeriod.period) {
                            scope.changeStatsPeriod(currentPeriod); // just update the current data
                        }
                    }, function () {
                        scope.viewModel.fetchingStatsMethodSet[currentPeriod].isUpdated = true;
                        scope.viewModel.isBusy = false;
                    });
                };
                scope.selectNextPeriod = function () {
                    for (var i in scope.viewModel.periodsOfStats) {
                        if (scope.viewModel.periodsOfStats[i] === scope.viewModel.currentPeriod.period) {
                            if ((parseInt(i) + 1) === scope.viewModel.periodsOfStats.length) {
                                return scope.viewModel.periodsOfStats[0];
                            }
                            else {
                                return scope.viewModel.periodsOfStats[parseInt(i) + 1];
                            }
                        }
                    }
                    return scope.viewModel.periodsOfStats[0];
                };
                scope.changePeriodInterval = null;
                scope.periodInterval = function () {
                    if (scope.changePeriodInterval) {
                        $interval.cancel(scope.changePeriodInterval);
                    }
                    scope.changePeriodInterval = $interval(function () {
                        elem.addClass('changingOfPeriod');
                        var nextPeriod = scope.selectNextPeriod();
                        scope.changeStatsPeriod(nextPeriod);
                    }, 30000);
                };
                scope.periodInterval();
                scope.changeStatsPeriod = function (period) {
                    scope.viewModel.currentPeriod.period = period;
                    scope.viewModel.classOfChangingPeriod = 'changingOfPeriod';
                    var valuesForCurrentPeriod = scope.viewModel.fetchingStatsMethodSet[period].values;
                    switch (period) {
                        case '7days':
                            scope.viewModel.stats.emailSent.value = valuesForCurrentPeriod.last7DaysEmailSent;
                            scope.viewModel.stats.smsSent.value = valuesForCurrentPeriod.last7DaysSmsSent;
                            scope.viewModel.stats.voiceSent.value = valuesForCurrentPeriod.last7DaysVoiceSent;
                            scope.viewModel.currentPeriod.widgetHeader = '_messagesSent7DaysWidget_';
                            break;
                        case '30days':
                            scope.viewModel.stats.emailSent.value = valuesForCurrentPeriod.last30DaysEmailSent;
                            scope.viewModel.stats.smsSent.value = valuesForCurrentPeriod.last30DaysSmsSent;
                            scope.viewModel.stats.voiceSent.value = valuesForCurrentPeriod.last30DaysVoiceSent;
                            scope.viewModel.currentPeriod.widgetHeader = '_messagesSent30DaysWidget_';
                            break;
                        default:
                            //today
                            scope.viewModel.stats.emailSent.value = valuesForCurrentPeriod.todayEmailSent;
                            scope.viewModel.stats.smsSent.value = valuesForCurrentPeriod.todaySmsSent;
                            scope.viewModel.stats.voiceSent.value = valuesForCurrentPeriod.todayVoiceSent;
                            scope.viewModel.currentPeriod.widgetHeader = '_messagesSentTodayWidget_';
                            break;
                    }
                    $timeout(function () {
                        elem.removeClass('changingOfPeriod');
                    }, 1000);
                };
                scope.changeStatsPeriodByClick = function () {
                    elem.addClass('changingOfPeriod');
                    scope.periodInterval();
                    scope.updateStatsInterval();
                    var nextPeriod = scope.selectNextPeriod();
                    scope.changeStatsPeriod(nextPeriod);
                    scope.getMessagesTodayStats();
                };
                scope.getMessagesTodayStats();
                scope.stopHandler = null;
                scope.updateStatsInterval = function () {
                    if (!scope.viewModel.updateInterval) {
                        return;
                    }
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                    scope.stopHandler = $interval(function () {
                        scope.getMessagesTodayStats();
                    }, Math.abs(scope.viewModel.updateInterval));
                };
                scope.updateStatsInterval();
                scope.stopTimer = function () {
                    if (scope.stopHandler) {
                        $interval.cancel(scope.stopHandler);
                    }
                    $interval.cancel(scope.changePeriodInterval);
                };
                scope.$on('$destroy', function () {
                    console.log("destroy MISSED widget");
                    scope.stopTimer();
                });
                scope.$on("$locationChangeStart", function (event, next, current) {
                    scope.stopTimer();
                });
                $rootScope.$on('event:auth-logout', function () {
                    scope.stopTimer();
                });
                elem.on('mouseover', function () {
                    elem.find('.messagingReport').show();
                });
                elem.on('mouseleave', function () {
                    elem.find('.messagingReport').hide();
                });
                scope.openMessagingReport = function () {
                    $location.path('/reports/messaging');
                };
            }
        };
    }]);
//# sourceMappingURL=messaging.directive.js.map